import type { useTranslations } from "next-intl"

/**
 * 번역 키가 존재하면 번역값을, 없으면 fallback을 반환한다.
 * locale이 "qaa"(디버그)일 때는 항상 t(key)를 호출하여 🔑key 형태로 표시한다.
 */
export function tWithFallback(t: ReturnType<typeof useTranslations>, locale: string, key: string, fallback: string): string {
	if (locale === "qaa") return t(key)
	return t.has(key) ? t(key) : fallback
}
